import styled from 'styled-components';
import { Stack } from '@karma/components';

export const Container = styled(Stack)`
  max-width: 1170px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 60px;
`;
